import React, { useContext } from 'react';
import RecorderDrawerContext from '../../Context';

export function MultipleProfileDetails() {
  const { profiles } = useContext(RecorderDrawerContext);

  if (!profiles) return <></>;

  return (
    <span className='text-[21px] font-bold'>{profiles.length} Contacts</span>
  );
}
